import { skipToken, useQuery } from "@apollo/client/react";

import { TokenAggregationAsCreatorDocument } from "@/graphql/codegen/graphql";
import { tokenNanosToInteger } from "@/utils/currency";

export const useTotalSupply = ({ publicKey }: { publicKey: string }) => {
  const { data, loading: loadingFetchTokenAggAsCreatorData } = useQuery(
    TokenAggregationAsCreatorDocument,
    publicKey
      ? {
          fetchPolicy: "network-only",
          variables: {
            publicKey,
          },
        }
      : skipToken,
  );

  const totalSupply = tokenNanosToInteger(
    data?.account?.tokenAggAsCreator?.totalBalanceNanos || 0,
  );

  return { totalSupply, loadingTotalSupply: loadingFetchTokenAggAsCreatorData };
};
